export function parseToEasternTime(date) {
  if (!date) {
    return " - "
  }
  try {
    let easternTimeZone = 'America/New_York'
    if (typeof (date) === 'string' && !date.endsWith('Z')) date = date + 'Z'
    let easternTimeDate = changeTimeZone(date, easternTimeZone);

    return `${easternTimeDate.slice(0, -3)}${easternTimeDate.slice(-2)}`.replace(",", "")
  } catch (err) {
    console.log("Error formatting dates: ", err)
    return " - "
  }
}

export function changeTimeZone(date, timeZone) {
  try {
    //A: if the input is a date string it will return the formatted date as a string
    if (typeof date === 'string') {
      return new Date(date)
        .toLocaleString('en-US', {
          timeZone,
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          //timeZoneName: 'short',
        })
    } else if (typeof date === 'object') {
      //A: if the input is a date object it will return the formatted date as a string
      return date.toLocaleString('en-US', {
        timeZone,
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        //timeZoneName: 'short',
      })
    } else {
      return " - "
    }
  } catch (err) {
    console.log("Error formatting dates: ", err)
    return " - "
  }

}

export function dateFormatter(date) {
  try {
    if (typeof date === 'string') {
      return new Date(date).toLocaleString('en-US', {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        //timeZoneName: 'short',
      })
    } else if (typeof date === 'object') {
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        //timeZoneName: 'short',
      })
    } else {
      return " - "
    }

  } catch (err) {
    console.log("Error formatting dates: ", err)
    return " - "
  }
}

export function eventDatesFormatter(date, config = {}) {
  console.log("date: ", date)
  //Wed - Sep 14 2022 - 8:00 PM
  const defaultConfig = {
    showWeekday: true,
  };

  const finalConfig = { ...defaultConfig, ...config };

  try {
    // Base options for formatting the date
    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    };

    // Include the weekday in the formatted date if specified
    if (finalConfig.showWeekday) {
      options.weekday = 'short';
    }

    if (typeof date === 'string') {
      return new Date(date).toLocaleString('en-US', options).replace(/, /g, ' - ');
    } else if (typeof date === 'object') {
      return date.toLocaleString('en-US', options).replace(/, /g, ' - ');
    } else {
      return " - ";
    }
  } catch (err) {
    console.log("Error formatting dates: ", err);
    return " - ";
  }
}

export function getMinutesAgo(timestamp) {
  if (typeof (timestamp) === 'string' && !timestamp.endsWith('Z')) timestamp = timestamp + 'Z'
  let dateMiliseconds = Date.parse(timestamp)
  let ago = Date.now() - dateMiliseconds

  return Math.floor(ago / 60000)
}

export function dateToUTCIsoString(date = new Date()) {
  // A: using the actual date as default
  // this function takes the local time zone date object. parses to UTC and then returns the UTC isoString
  return date.toISOString().split("Z")[0]

}

// Juan Bautista function used to parse Dates in Admin Swarms

//Output 4/28/23 12:30PM
export function toStdDate(date){
  // Convert the value to a Date object
  const eventDate = new Date(date);

  // Format the date part as "MM/DD/YYYY" using the toLocaleDateString method
  let formattedDate = `${eventDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  })}`;

  // Format the time part as "HH:MM" using the toLocaleTimeString method
  const formattedTime = `${eventDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;

  // remove leading zeros except in minutes
  const fDate = formattedDate.replace(/\b0/g, "")
  const fTime = formattedTime.split(":")[0].replace(/\b0/g, "") + ":" + formattedTime.split(":")[1]

  // Combine the formatted date and time parts with a space in between
  const formattedDateTime = `${fDate} ${fTime}`;

  // Return the formatted date and time string
  return formattedDateTime;
}

//Output Mo 4/28/23 12:30PM
export function toStdDateWeekday(date){
  // Convert the value to a Date object
  const eventDate = new Date(date);

  // Format the date part as "MM/DD/YYYY" using the toLocaleDateString method
  let formattedDate = `${eventDate.toLocaleDateString("en-US", {
    weekday: 'short',
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  })}`;

  // Format the time part as "HH:MM" using the toLocaleTimeString method
  const formattedTime = `${eventDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;

  // remove leading zeros except in minutes
  const fDate = formattedDate.replace(/\b0/g, "")
  // remove commas
  .split(",").join("")
  
  // get only the first two letters of the weekday
  const dayOfWeek = fDate.substring(0, 2);
  
  const fTime = formattedTime.split(":")[0].replace(/\b0/g, "") + ":" + formattedTime.split(":")[1]

  // Combine the formatted date and time parts with a space in between
  const formattedDateTime = `${dayOfWeek} ${fDate.slice(3)} ${fTime}`;

  // Return the formatted date and time string
  return formattedDateTime;
}

export function convertToLocalTimezone(timestamp) {
  //console.log("convertToLocalTimezone, input: ", timestamp)
  try {
    const utcDate = new Date(timestamp);
    //console.log("convertToLocalTimezone, utcDate: ", utcDate)
    let isoString = utcDate.toISOString();
    //console.log("convertToLocalTimezone, isoString: ", isoString)
    // remove Z from the ISO string so it is compatible with the dateFormatter function
    let dateString = isoString.split("Z")[0];
    console.log("convertToLocalTimezone, dateString: ", dateString)
    // convert the date string to a date object
    let date = new Date(dateString).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });;

    console.log("convertToLocalTimezone, date: ", date)
    let res = date;
    // add the time to the date string
    console.log("convertToLocalTimezone, res: ", res)
    // return the date string
    return res
  }
  catch (err) {
    console.error("Error converting to local timezone: ", err);
    return " - ";
  }
}

/**
 * 
 * @param {string} date 
 * @returns {string} - formatted date in the format of "MM/DD/YYYY HH:MMAM/PM" (e.g., "6/6/2023 12:30PM") without any leading zeros
 */
export function eventDateGridFormatter(date){
  // Convert the value to a Date object
  const eventDate = new Date(date);

  // Format the date part as "MM/DD/YYYY" using the toLocaleDateString method
  let formattedDate = `${eventDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  })}`;

  // Format the time part as "HH:MM" using the toLocaleTimeString method
  const formattedTime = `${eventDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;

  // remove leading zeros except in minutes
  const fDate = formattedDate.replace(/\b0/g, "")
  const fTime = formattedTime.split(":")[0].replace(/\b0/g, "") + ":" + formattedTime.split(":")[1]

  // Combine the formatted date and time parts with a space in between
  const formattedDateTime = `${fDate} ${fTime}`;

  // Return the formatted date and time string
  return formattedDateTime;
}

//example: 2024-02-12T00:00:00
export function formatDateRangeToString(startDateStr, endDateStr) {
  // Convert the date strings into Date objects
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Function to add leading zeros if needed
  const addLeadingZero = (num) => (num < 10 ? "0" + num : num);

  // Get the components of the start date
  const startDay = addLeadingZero(startDate.getDate());
  const startMonth = addLeadingZero(startDate.getMonth() + 1); // Months in JavaScript are zero-based
  const startYear = startDate.getFullYear();

  // Get the components of the end date
  const endDay = addLeadingZero(endDate.getDate());
  const endMonth = addLeadingZero(endDate.getMonth() + 1); // Months in JavaScript are zero-based
  const endYear = endDate.getFullYear();

  // Format the dates according to the desired format
  const formattedStartDate = `${startMonth}/${startDay}/${startYear}`;
  const formattedEndDate = `${endMonth}/${endDay}/${endYear}`;

  // Concatenate the formatted dates with a hyphen
  const formattedDateRange = `${formattedStartDate}-${formattedEndDate}`;

  return formattedDateRange;
}



// ------------------ Documentation ----------------------

// parseToEasternTime(date)
// Input: date (string or Date object)
// Output: Eastern Time formatted as "MM/DD/YYYY HH:MMAM/PM" (e.g., "06/06/2023 12:30PM")

// changeTimeZone(date, timeZone)
// Input: date (string or Date object), timeZone (string)
// Output: Formatted date based on the provided time zone. The format is the same as in parseToEasternTime.

// dateFormatter(date)
// Input: date (string or Date object)
// Output: Date formatted as "MM/DD/YYYY HH:MMAM/PM" (e.g., "06/06/2023 12:30PM")

// eventDatesFormatter(date)
// Input: date (string or Date object)
// Output: Date formatted as "Weekday - Month DD YYYY - HH:MMAM/PM" (e.g., "Wed - Sep 14 2022 - 8:00 PM")

// getMinutesAgo(timestamp)
// Input: timestamp (string or Date object)
// Output: Number of minutes elapsed since the provided timestamp.

// dateToUTCIsoString(date)
// Input: date (Date object, optional, default is current date)
// Output: UTC ISO string of the provided date (e.g., "2023-06-06T12:30:00")

// toStdDate(date, opts)
// Input: date (Date object), opts (optional object with properties: time and date)
// Output: Standardized date and time format as "MM/DD/YY HH:MM AM/PM" (e.g., "04/28/23 9:06PM") based on the provided options. The default options display both the date and time.


// convertToLocalTimezone(timestamp)

// This function takes a UTC timestamp as input and converts it to the user's local timezone.

// Input: timestamp (string) - A UTC timestamp in the format "YYYY-MM-DDTHH:MM:SS" (e.g., "2023-03-03T15:00:00").
// Output: Date formatted in the user's local timezone using the dateFormatter function format.
// Please note that the convertToLocalTimezone function relies on the browser's or environment's default timezone settings to determine the user's local timezone.

// eventDateGridFormatter(date)
// This function takes a date (string or Date object) and returns a formatted date and time string suitable for event grids.
// Input:
//   - date (string or Date): The date to be formatted.
// Output:
//   - Formatted date and time string in the format "MM/DD/YYYY HH:MM" (e.g., "06/06/2023 12:30").
// Example:
//   eventDateGridFormatter("2023-06-06T12:30:00");
//   Output: "06/06/2023 09:06 AM/PM"